export default {
  quantities: ['4', '10', '50', '100'],
};
